import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

// A link that understands three kinds of targets:
//   • external  (http…)        -> opens in a new tab
//   • home section (/#id, #id) -> navigates to the homepage and scrolls to #id
//   • route     (/about, …)    -> normal SPA navigation
export default function SmartLink({ to, children, className, onClick, ...props }) {
  const navigate = useNavigate();
  const location = useLocation();
  const href = to || '/';

  if (/^https?:\/\//i.test(href)) {
    return (
      <a className={className} href={href} target="_blank" rel="noreferrer" onClick={onClick} {...props}>
        {children}
      </a>
    );
  }

  const hashMatch = href.match(/^\/?#(.+)$/);
  if (hashMatch) {
    const id = hashMatch[1];
    const handle = (e) => {
      e.preventDefault();
      if (onClick) onClick();
      const scrollToSection = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      };
      if (location.pathname !== '/') {
        navigate('/');
        // wait for the homepage to mount before scrolling
        setTimeout(scrollToSection, 300);
      } else {
        scrollToSection();
      }
    };
    return (
      <a className={className} href={`/#${id}`} onClick={handle} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={href} onClick={onClick} {...props}>
      {children}
    </Link>
  );
}
